import { Loader } from '@servicetitan/web-components';

function App() {
  const params = Object.fromEntries(  
    new URLSearchParams(window.location.search)
  )

  const tag = process.env.REACT_APP_MFE_TAG || "latest";
  console.log(`Prequals landing: ${tag}`);

  return (
    <div>
      <Loader
        src={`https://unpkg.servicetitan.com/@servicetitan/prequals-landing@${tag}`}
        data={params}
        loadingFallback={null}
      />
    </div>
  );
}

export default App;
